import { withVersions } from "v2/hocs/withVersions";
import withSkeleton from "../hocs/withSkeleton";
import SkeletonBarV1UI from "./SkeletonBar/v1";
import SkeletonDotV1UI from "./SkeletonDot/v1";
import SkeletonLogoV1UI from "./SkeletonLogo/v1";
const Skeleton = {
  Bar: withVersions({
    v1: withSkeleton(SkeletonBarV1UI),
    v2: withSkeleton(SkeletonBarV1UI),
  }),
  Dot: withVersions({
    v1: withSkeleton(SkeletonDotV1UI),
    v2: withSkeleton(SkeletonDotV1UI),
  }),
  Logo: withVersions({
    v1: withSkeleton(SkeletonLogoV1UI),
    v2: withSkeleton(SkeletonLogoV1UI),
  }),
};

export default Skeleton;
